import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LessonTable from './LessonTable';
const Lessons = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Lesson' parent='Lesson'  />
      <Container fluid={true}>
        <Row>
          <LessonTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Lessons;
